import GrandPrixNavbar from "../../components/GrandPrix/GrandPrixNavbar";
import { useParams } from "react-router-dom";
import GrandPrixStages from "../../components/GrandPrix/GrandPrixStages";
import ErrorPage from "../ErrorPage";

const Stages = () => {
  let { grandprix } = useParams();
  if (grandprix == null) return <ErrorPage />; //just in case gp name does not exist
  return (
    <div className="full-height padding-md app-container page-transition">
      <GrandPrixNavbar name={grandprix} active={13} />
      <GrandPrixStages grand_prix_name={grandprix} />
    </div>
  );
};

export default Stages;
